import { DropdownItem, UncontrolledTooltip } from "reactstrap";
import Text from "components/Text";
import infoIcon from "assets/images/info_black-tooltip.svg";
import styles from "./OtherOwnerActionInfo.module.scss";

/**
 * Edit/Delete dropdown action that can be blocked (other-owner or role),
 * with an info icon and tooltip explaining why.
 *
 * @param {{
 *  label: string,
 *  tooltip: string,
 *  tooltipId: string,
 *  isOtherOwner?: boolean,
 *  disabled?: boolean,
 *  onMouseDown?: (event: import("react").MouseEvent) => void,
 *  onClick: (event?: import("react").MouseEvent) => void,
 * }} props
 */
export default function OtherOwnerAwareDropdownItem({
  label,
  tooltip,
  tooltipId,
  isOtherOwner = false,
  disabled,
  onMouseDown,
  onClick,
}) {
  const isDisabled = disabled ?? isOtherOwner;

  return (
    <>
      <DropdownItem
        id={isDisabled ? tooltipId : undefined}
        className={isDisabled ? styles["action-item"] : undefined}
        onMouseDown={onMouseDown}
        onClick={(event) => {
          if (isDisabled) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }
          onClick?.(event);
        }}
      >
        <Text
          className={`office-dropdown-item${
            isDisabled ? ` ${styles["disabled-label"]}` : ""
          }`}
        >
          {label}
        </Text>
        {isDisabled && (
          <span
            className={styles["info-wrap"]}
            onClick={(event) => event.stopPropagation()}
            aria-label={tooltip}
          >
            <img src={infoIcon} alt="" className={styles["info-icon"]} />
          </span>
        )}
      </DropdownItem>
      {isDisabled && (
        <UncontrolledTooltip
          placement="left"
          target={tooltipId}
          container="body"
        >
          {tooltip}
        </UncontrolledTooltip>
      )}
    </>
  );
}
